import { http, HttpResponse } from "msw"
import type { ApiLabSales } from "../../laboratorySales"
import { labPerfSalesMock } from "./labSales.mock"

const API_DOMAIN = import.meta.env.VITE_API_DOMAIN

export const financialDataLabSales = [
  http.get(`${API_DOMAIN}/api/financial-data/laboratory/sales`, () =>
    HttpResponse.json<ApiLabSales>(labPerfSalesMock()),
  ),
  http.get(`${API_DOMAIN}/api/financial-data/laboratories/:labId/sales`, () =>
    HttpResponse.json<ApiLabSales>(labPerfSalesMock()),
  ),
]
